export default __webpack_public_path__ + "static/media/resize-1715367284714733201Component1.ae953676.jpg";